export const AUTO_APPROVED = 'Auto Approved'
export const MANUALLY_APPROVED = 'Manually Approved'
export const REJECTED = 'Rejected'
export const OPERATING_COMPANY_TARGET = 'Target Stores'
export const OPERATING_COMPANY_TARGET_VALUE = 4
export const OPERATING_COMPANY_DVS = 'Target.com'
export const OPERATING_COMPANY_DVS_VALUE = 5
export const OPERATING_COMPANY_IMPORT = 'TGSL'
export const OPERATING_COMPANY_IMPORT_VALUE = 95
